import React from "react"
import {ReadyToLaunchCard} from "../../../containers/ReadyToLaunchCard/ReadyToLaunchCard"
import {ProgramPerformanceItemCard} from "../../ProgramPerformanceItemCard/ProgramPerformanceItemCard"
import {ProgramPerformanceItem} from "../../ProgramPerformanceItemCard/types"
import classNames from "classnames"

interface ProgramPerformanceCardProps {
	items: ProgramPerformanceItem[]
	className?: string
}

export function ProgramPerformanceCard({items, className}: ProgramPerformanceCardProps) {
	return (
		<ReadyToLaunchCard title="Your Program Performance" className={classNames("program-performance-card", className)}>
			<div className="columns is-multiline">
				{items.map((item, index) => (
					<div key={index} className="column is-one-quarter">
						<ProgramPerformanceItemCard {...item} />
					</div>
				))}
			</div>
		</ReadyToLaunchCard>
	)
}
